/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportListConnectionsQueryResponse, SocialExportListConnectionsQueryParams, SocialExportListConnections400, SocialExportListConnections401, SocialExportListConnections403 } from "../models/SocialExportListConnections";

export function getSocialExportListConnectionsUrl() {
  const res = { method: 'GET', url: `/social-export/v1/connections` as const }
  return res
}

/**
 * @description Returns every social platform connection belonging to the authenticated client, with connection state, profile info, and linked station IDs. Optionally filter by platform.
 * @summary List all connection states for the client
 * {@link /social-export/v1/connections}
 */
export async function socialExportListConnections(params?: SocialExportListConnectionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportListConnectionsQueryResponse, ResponseErrorConfig<SocialExportListConnections400 | SocialExportListConnections401 | SocialExportListConnections403>, unknown>({ method : "GET", url : getSocialExportListConnectionsUrl().url.toString(), params, ... requestConfig })
  return res.data
}